import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { DynamicsCrmEntityDataset } from 'app/model/dataset/dynamics-crm.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: adfModelTypeMap.dynamicsCRM.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(DynamicsCrmEntityDataset) }
})
export class DynamicsCrmCopySource extends TabularCopySource {
}
